import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProductDetailView from '../views/ProductDetailView.vue'
import DealersView from '../views/DealersView.vue'
import AboutView from '../views/AboutView.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/products/:id', name: 'product-detail', component: ProductDetailView },
    { path: '/dealers', name: 'dealers', component: DealersView, props: { serviceMode: false } },
    { path: '/service-providers', name: 'service-providers', component: DealersView, props: { serviceMode: true } },
    { path: '/about', name: 'about', component: AboutView },
    { path: '*', redirect: '/' }
  ],
  scrollBehavior (to) {
    if (to.hash) return { selector: to.hash, behavior: 'smooth' }
    return { x: 0, y: 0 }
  }
})

export default router
